import {useTranslation} from 'react-i18next';
import {Skeleton} from '@chekinapp/ui';
import {PageLayout} from 'components/PageLayout';
import {IVStepsSkeleton} from './IVStepsSkeleton';

function IdentityVerificationSkeleton() {
  const {t} = useTranslation();

  return (
    <PageLayout hideBack>
      <div
        role="status"
        aria-label={t('loading')}
        className="flex flex-col gap-6 sm:gap-8"
      >
        <div className="flex flex-col gap-2.5">
          <Skeleton className="h-[11px] w-[104px] rounded" />
          <Skeleton className="mt-1 h-[26px] w-[70%] rounded-lg" />
          <Skeleton className="h-[13px] w-full rounded" />
          <Skeleton className="h-[13px] w-[56%] rounded" />
        </div>

        <IVStepsSkeleton />

        <Skeleton className="h-[var(--button-height-default)] w-full max-w-[340px] self-center rounded-xl" />
      </div>
    </PageLayout>
  );
}

export {IdentityVerificationSkeleton};
